import { render, staticRenderFns } from "./statisticsBox.vue?vue&type=template&id=b7b44f0c&scoped=true&"
import script from "./statisticsBox.vue?vue&type=script&lang=js&"
export * from "./statisticsBox.vue?vue&type=script&lang=js&"
import style0 from "./statisticsBox.vue?vue&type=style&index=0&id=b7b44f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b44f0c",
  null
  
)

component.options.__file = "statisticsBox.vue"
export default component.exports